var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5001 42.5728C33.2085 42.5728 42.7385 33.0428 42.7385 21.3345C42.7385 9.62612 33.2085 0.0960693 21.5001 0.0960693C9.79177 0.0960693 0.261719 9.62612 0.261719 21.3345C0.261719 33.0428 9.79177 42.5728 21.5001 42.5728ZM21.5001 1.18522C32.6094 1.18522 41.6493 10.2251 41.6493 21.3345C41.6493 32.4438 32.6094 41.4837 21.5001 41.4837C10.3908 41.4837 1.35087 32.4438 1.35087 21.3345C1.35087 10.2251 10.3908 1.18522 21.5001 1.18522Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9825 15.1166L18.9064 28.7866L11.666 21.5461",
    stroke: "#111111",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSuccess);
export default __webpack_public_path__ + "static/media/chat-success.6e438ec1d90c76db2bee87a749b41bf3.svg";
export { ForwardRef as ReactComponent };